export default __webpack_public_path__ + "static/media/pedidos_ringtone.4c26c4f3.mp3";